"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.to-string");
var _login2 = require("@/api/login");
var _auth = require("@/utils/auth");
var _cryptoJs = _interopRequireDefault(require("crypto-js"));
var _router = _interopRequireWildcard(require("@/router"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
var state = {
  token: (0, _auth.getToken)(),
  name: '',
  loginName: '',
  avatar: '',
  introduction: '',
  roles: [],
  // 用户拥有的按钮资源
  btns: [],
  orgGroup: '',
  orgName: ''
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_BTNS: function SET_BTNS(state, btns) {
    // 设置用户资源按钮
    state.btns = btns;
  },
  SET_ORG_GROUP: function SET_ORG_GROUP(state, orgGroup) {
    state.orgGroup = orgGroup;
  },
  SET_ORGNAME: function SET_ORGNAME(state, orgName) {
    state.orgName = orgName;
  },
  SET_ORGGROUPNAME: function SET_ORGGROUPNAME(state, orgGroupName) {
    state.orgGroupName = orgGroupName;
  },
  SET_ORGGROUPID: function SET_ORGGROUPID(state, orgGroupId) {
    state.orgGroupId = orgGroupId;
  },
  SET_LOGINNAME: function SET_LOGINNAME(state, loginName) {
    state.loginName = loginName;
  }
};
var actions = {
  // user login
  login: function login(_ref, userInfo) {
    var commit = _ref.commit;
    var username = userInfo.username,
      password = userInfo.password;
    return new Promise(function (resolve, reject) {
      var passWd = _cryptoJs.default.SHA256(password).toString();
      (0, _login2.login)({
        username: username.trim(),
        password: passWd
      }).then(function (response) {
        var data = response.data;
        commit('SET_TOKEN', data.token);
        (0, _auth.setToken)(data.token);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  //企业微信登录
  wxWorkLogin: function wxWorkLogin(_ref2, authLoginData) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      (0, _login2.wxWorkLogin)(authLoginData).then(function (response) {
        var data = response.data;
        commit('SET_TOKEN', data.token);
        (0, _auth.setToken)(data.token);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 获取用户信息
  getUserInfo: function getUserInfo(_ref3) {
    var commit = _ref3.commit,
      state = _ref3.state;
    return new Promise(function (resolve, reject) {
      var cacheKey = 'mall_user_info_cache';
      var doProcess = function doProcess(response) {
        var orgGroupId = null,
          orgGroupName = null,
          orgGroupCode = null;
        var data = response.data;
        var orgName = data.orgName;
        if (data.roles && data.roles.length > 0) {
          commit('SET_ROLES', data.roles);
        } else {
          reject('getInfo: roles must be a non-null array ! ');
          return;
        }
        var orgGroup = data.orgGroup;
        if (orgGroup) {
          orgGroupName = orgGroup.orgGroupName;
          orgGroupId = orgGroup.orgGroupId;
          orgGroupCode = orgGroup.orgGroupCode;
        }
        commit('SET_NAME', data.nickname);
        sessionStorage.setItem('userBtns', data.perms);
        commit('SET_AVATAR', data.avatar);
        commit('SET_LOGINNAME', response.userName);
        commit('SET_ORGNAME', orgName);
        commit('SET_ORGGROUPID', orgGroupId);
        commit('SET_ORGGROUPNAME', orgGroupName);
        commit('SET_ORG_GROUP', orgGroupCode);
        resolve(response);
      };

      // 同一会话内缓存，避免重复请求大体积权限数据
      var cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        try {
          doProcess(JSON.parse(cached));
          return;
        } catch (e) {
          sessionStorage.removeItem(cacheKey);
        }
      }
      (0, _login2.getInfo)().then(function (response) {
        sessionStorage.setItem(cacheKey, JSON.stringify(response));
        doProcess(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 用户退出
  logout: function logout(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state,
      dispatch = _ref4.dispatch;
    return new Promise(function (resolve, reject) {
      (0, _login2.logout)(state.token).then(function () {
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        (0, _auth.removeToken)();
        sessionStorage.removeItem('mall_user_info_cache');
        (0, _router.resetRouter)();
        dispatch('tagsView/delAllViews', null, {
          root: true
        });
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref5) {
    var commit = _ref5.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      (0, _auth.removeToken)();
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles: function changeRoles(_ref6, role) {
    var commit = _ref6.commit,
      dispatch = _ref6.dispatch;
    return new Promise(/*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve) {
        var token, res, data, accessRoutes;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              token = role + '-token';
              commit('SET_TOKEN', token);
              (0, _auth.setToken)(token);
              // by zjj
              _context.next = 1;
              return dispatch('user/getUserInfo');
            case 1:
              res = _context.sent;
              data = res.data.list; // router 连接
              // by zjj
              (0, _router.resetRouter)();

              // generate accessible routes map based on roles
              _context.next = 2;
              return dispatch('permission/generateRoutes', data, {
                root: true
              });
            case 2:
              accessRoutes = _context.sent;
              // dynamically add accessible routes
              _router.default.addRoutes(accessRoutes);

              // reset visited views and cached views
              dispatch('tagsView/delAllViews', null, {
                root: true
              });
              resolve();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref7.apply(this, arguments);
      };
    }());
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};